module.exports = __webpack_public_path__ + "img/Logo.0518a38f.jpg";